import { Link, useRouteError } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { SITE } from '@/data/site'

export default function NotFoundPage() {
  const error = useRouteError() as { statusText?: string; message?: string } | undefined

  return (
    <>
      <Helmet>
        <title>Page Not Found | W.B. Coin &amp; Jewelry</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <section className="min-h-screen flex items-center justify-center bg-cream-100 pt-20">
        <div className="text-center max-w-lg px-6">
          <p className="font-heading text-9xl font-bold text-primary-600/10 select-none leading-none" aria-hidden="true">
            404
          </p>
          <h1 className="font-heading text-3xl font-bold text-neutral-dark mt-2 mb-3">
            Page Not Found
          </h1>
          <p className="text-neutral-mid mb-8">
            {error?.statusText ?? error?.message ?? "The page you're looking for doesn't exist or has moved."}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="btn-primary btn btn-lg">
              Go to Homepage
            </Link>
            <a href={SITE.phoneHref} className="btn-navy btn btn-lg">
              Call {SITE.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  )
}
